module.exports = __webpack_public_path__ + "static/media/takraw.51a325e9.svg";